import React from "react";
import { Grid, makeStyles, Typography, Button, Paper } from "@material-ui/core";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { useLocation, useNavigate } from "react-router-dom";
import { formatAmount } from "utils/Utils";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "92%",
    margin: "0 auto",
    minHeight: "85vh",
  },

  mainContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 20px 30px",
    textAlign: "center",
  },

  image: {
    width: 120,
    height: 120,
  },

  title: {
    fontSize: 40,
    fontWeight: 700,
    color: "#173A7A",
  },

  headerText: {
    fontSize: 24,
    fontWeight: 600,
    color: "#222",
  },

  amount: {
    fontSize: 42,
    fontWeight: 700,
    color: "#14A44D",
    marginBottom: 10,
  },

  card: {
    width: "100%",
    maxWidth: 700,
    padding: 24,
    borderRadius: 12,
    marginBottom: 15,
  },

  item: {
    textAlign: "center",
  },

  label: {
    fontSize: 16,
    color: "#666",
    marginBottom: 6,
  },

  value: {
    fontSize: 22,
    fontWeight: 600,
    color: "#222",
  },

  info: {
    fontSize: 20,
    color: "#555",
    marginBottom: 24,
  },

  button: {
    width: 320,
    height: 52,
    borderRadius: 8,
    fontSize: 18,
    fontWeight: 600,
    textTransform: "none",
    background: "#16A34A",
    color: "#fff",
    "&:hover": {
      background: "#15803D",
    },
  },
}));

const CongraculationDetails = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const loanAmount = location.state?.loanAmount;

  const handleProceed = () => {
    navigate("/journey/SelfiePhoto");
  };

  return (
    <Grid container className={classes.container}>
      <Grid item xs={12}>
        {/* Removed Next Button */}
        <SubHeader label="Congratulations!" />
      </Grid>

      <Grid item xs={12} className={classes.mainContainer}>
        <img
          src="/images/congratulation.png"
          alt="Congratulations"
          className={classes.image}
        />
        <Typography className={classes.title}>Congratulations!</Typography>
        <Typography className={classes.headerText}>
          You are eligible for a loan up to
        </Typography>
        <Typography className={classes.amount}>
          {formatAmount(loanAmount)}
        </Typography>
        <Typography className={classes.info}>
          Click <strong>Proceed</strong> to continue your loan application.
        </Typography>
        <Button
          variant="contained"
          className={classes.button}
          onClick={handleProceed}
        >
          Proceed
        </Button>
      </Grid>
    </Grid>
  );
};

export default CongraculationDetails;